import api from "../api";

export const getDashboardStats = () => {
  return api.getApi().get(api.getBaseUrl() + "dashboard/stats");
};

export const getDetailedReport = () => {
  return api.getApi().get(api.getBaseUrl() + "dashboard/detailed-report");
};

export const getMyPayments = () => {
  return api.getApi().get(api.getBaseUrl() + "dashboard/my-payments");
};

export const getMyPaymentsCommissions = (data) => {
  return api
    .getApi()
    .get(api.getBaseUrl() + "dashboard/my-payments-commissions", {
      params: {
        page: data.page,
        pageSize: data.pageSize,
        nameFilter: data.nameFilter,
        emailNameFilter: data.emailNameFilter,
        statusFilter: data.statusFilter,
        countryFilter: data.countryFilter,
        sortColumn: data.sortColumn,
        sortDirection: data.sortDirection,
      },
    });
};

export const downloadMyPaymentsCommissionsExcel = (params) => {
  return api
    .getApi()
    .get(api.getBaseUrl() + "dashboard/my-payments-commissions/download-excel", {
      params,
      responseType: "blob",
    });
};

export const getMyPaymentsCommissionDetails = (data) => {
  return api
    .getApi()
    .get(api.getBaseUrl() + "dashboard/my-payments-commission-details", {
      params: {
        page: data.page,
        pageSize: data.pageSize,
        nameFilter: data.nameFilter,
        emailNameFilter: data.emailNameFilter,
        statusFilter: data.statusFilter,
        lucaIdFilter: data.lucaIdFilter,
        countryFilter: data.countryFilter,
        managerNameFilter: data.managerNameFilter,
        sortColumn: data.sortColumn,
        sortDirection: data.sortDirection,
      },
    });
};

export const downloadMyPaymentsCommissionDetailsExcel = (params) => {
  return api
    .getApi()
    .get(api.getBaseUrl() + "dashboard/my-payments-commission-details/download-excel", {
      params,
      responseType: "blob",
    });
};

export const getPaymentCountries = () => {
  return api.getApi().get(api.getBaseUrl() + "dashboard/payment-countries");
};

export const getPaymentsByCountry = (country) => {
  return api
    .getApi()
    .get(api.getBaseUrl() + "dashboard/payments-by-country", {
      params: { country },
    });
};

export const getCountryPaymentFinancials = (country, paymentIds) => {
  return api.getApi().post(api.getBaseUrl() + "dashboard/country-payment-financials", {
    country,
    paymentIds,
  });
};
